import { Component } from '@angular/core';

@Component({
  selector: 'pl-container',
  templateUrl: './container.component.html',
})
export class ContainerComponent {}
